import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Link, Typography } from "@mui/material";
import { T } from "../../util/t";
import { useDialogState } from "../../../hooks/useDialogState";
import { AccessTimeFilled } from "@mui/icons-material";
import { useEvent } from "../../routes/events/id/EventProvider";

export const WaitlistedRegistrationExplainer = () => {
    const [dialogOpen, openDialog, closeDialog] = useDialogState();

    return (
        <Box display="flex" alignItems="flex-start">
            <AccessTimeFilled/>
            <Box marginLeft={1}>
                <Typography variant="label1" component="p">
                    <T>Waitlisted event</T>
                </Typography>
                <Typography variant="body2" component="p">
                    <T>You won’t be charged yet.</T>&nbsp;
                    <Link underline="always" variant="inherit" onClick={openDialog}><T>More details.</T></Link>
                </Typography>
            </Box>
            <Dialog
                open={dialogOpen}
                onClose={closeDialog}
                className="lh-dialog"
                aria-labelledby="waitlisted-explainer-dialog-title"
                aria-describedby="waitlisted-explainer-dialog-description">
                <ModalContent onClose={closeDialog}/>
            </Dialog>
        </Box>
    );
};
export const ModalContent = ({ onClose }) => {
    const event = useEvent();

    return <>
        <DialogTitle id="waitlisted-explainer-dialog-title">
            <T>Waitlisted event</T>
        </DialogTitle>

        <DialogContent id="waitlisted-explainer-dialog-description">
            <Typography component="p" my={3}>
                <T>As payment is required for this event, you will need to provide payment details during registration. However, you will only be charged if and when your entry gets confirmed by the event organiser.</T>
            </Typography>

            <Typography variant="caption" component="p" my={3}>
                <T organisationName={event.organisation.name}>subject_to_organiser_discretion</T>
            </Typography>

        </DialogContent>

        <DialogActions className="sticky-dialog-actions">
            <Button variant="contained" onClick={onClose} fullWidth>
                <T>Okay</T>
            </Button>
        </DialogActions>
    </>;
};
